<template>
  <div style="background: #f4f4f4">
    <van-sticky>
      <van-nav-bar title="提交订单" left-arrow @click-left="onClickLeft" />
    </van-sticky>

    <div class="container">
      <div
        style="margin-left: 10px; margin-right: 10px; margin-top: 10px"
        class="submit-order"
      >
        <div v-if="!userAddr">
          <van-contact-card type="add" @click="onAdd" />
        </div>
        <div
          style="border-radius: 8px"
          class="delivery-addr"
          v-if="userAddr"
          @click="onAdd"
        >
          <div class="addr-bg whole">
            <div class="addr-icon">
              <img
                src="http://img.zhujiaxian.com/2023/10/75cef56efc1940b49965d77ad471830a.png"
                alt=""
              />
            </div>
            <div class="user-info">
              <span class="item">{{ userAddr.receiver }}</span>
              <span class="items">{{ userAddr.mobile }}</span>
            </div>
            <div class="addr">
              {{ userAddr.province }}{{ userAddr.city }}{{ userAddr.area
              }}{{ userAddr.addr }}
            </div>
            <div class="arrow"></div>
          </div>
          <div class="address-wrap"></div>
        </div>
        <div class="prod-item">
          <div class="prod-block">
            <div
              class="item-box"
              v-for="(item, index) in shopCartItems"
              :key="index"
            >
              <div class="item-cont">
                <div class="prod-pic">
                  <img :src="item.pic" alt="" />
                </div>
                <div class="prod-info">
                  <div class="prodname">{{ item.prodName }}</div>
                  <div class="price-nums">
                    <span class="prodprice">
                      <span style="color: #d03636" class="symbol">
                    <template v-if="activityId === 9 || activityId === 13">
                      <img src="https://img.zhujiaxian.com/2025/09/c5cc377d7c4c44f489ddc1130c867d08.png" style="width: 16px; height: 16px; margin-right: 4px;" />
                    </template>
                    <template v-else>
                      ￥
                    </template>
                  </span>
                      <span style="color: #d03636" class="big-num">{{
                        item.price.toFixed(2)
                      }}</span>
                    </span>
                    <span class="prodcount">x{{ item.prodCount }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="total-num">
            <span class="prodcount">
              共
              <span style="color: #d03636; font-weight: bold">{{
                totalCount
              }}</span
              >件商品
            </span>
            <div class="prodprice">
              合计
              <span style="color: #d03636" class="symbol">
                  <template v-if="activityId === 9">
                    <img src="https://img.zhujiaxian.com/2025/09/c5cc377d7c4c44f489ddc1130c867d08.png" style="width: 16px; height: 16px; margin-right: 4px;" />
                  </template>
                  <template v-else>
                    ￥
                  </template>
                </span>
              <span style="color: #d03636" class="big-num">{{
                total.toFixed(2)
              }}</span>
            </div>
          </div>
        </div>
        <div
          style="
            color: #939393;
            margin-top: 10px;
            margin-bottom: 10px;
            font-size: 16px;
          "
        >
          选择支付方式：
        </div>
        <div class="order-msg">
          <div class="msg-item">
            <div class="item coupon" style="display: block">
              <van-radio-group v-model="payType">
                <van-cell-group>
                  <van-cell
                    size="40"
                    :clickable="!(activityId === 13 || activityId === 15)"
                    :disabled="activityId === 13 || activityId === 15"
                    @click="payType = '9'"
                    icon="http://img.zhujiaxian.com/2023/10/5cfd4f021ea148039e274b1fbe2caf35.png"
                  >
                    <template #title>
                      <!-- <span class="custom-title">余额支付</span> -->
                      <span>可用余额：{{ isAccountFrozen ? '0' : userInfo.corporateAccounts }}</span>
                    </template>
                    <template #right-icon>
                      <van-radio :disabled="isAccountFrozen || (activityId === 13 || activityId === 15)" name="9" checked-color="#78C743" />
                    </template>
                  </van-cell>
                  <!-- 云闪付 -->
                  <van-cell
                    size="40"
                    :clickable="!(activityId === 13 || activityId === 15)"
                    :disabled="activityId === 13 || activityId === 15"
                    @click="payType = '52'"
                    icon="https://img.zhujiaxian.com/2026/07/f4ba00e953084459831a6e13caad67d4.jpg"
                  >
                    <template #title>
                      <span class="custom-title">云闪付</span>
                    </template>
                    <template #right-icon>
                      <van-radio name="52" checked-color="#78C743" :disabled="activityId === 13 || activityId === 15" />
                    </template>
                  </van-cell>
                </van-cell-group>
              </van-radio-group>
            </div>
          </div>
        </div>
        <div
          style="
            color: #939393;
            margin-top: 10px;
            margin-bottom: 10px;
            font-size: 16px;
          "
        >
          订单明细：
        </div>
        <div class="order-msg">
          <div class="msg-item">
            <div class="item">
              <div class="item-tit">订单总额：</div>
              <div class="item-txt price">
                <span class="symbol">
                    <template v-if="activityId === 9 || activityId === 13">
                      <img src="https://img.zhujiaxian.com/2025/09/c5cc377d7c4c44f489ddc1130c867d08.png" style="width: 16px; height: 16px; margin-right: 4px;" />
                    </template>
                    <template v-else>
                      ￥
                    </template>
                  </span>
                <span class="big-num">{{ total.toFixed(2) }}</span>
              </div>
            </div>
            <div class="item">
              <div class="item-tit">运费：</div>
              <div class="item-txt price">
                <span class="symbol">
                    <template v-if="activityId === 9 || activityId === 13">
                      <img src="https://img.zhujiaxian.com/2025/09/c5cc377d7c4c44f489ddc1130c867d08.png" style="width: 16px; height: 16px; margin-right: 4px;" />
                    </template>
                    <template v-else>
                      ￥
                    </template>
                  </span>
                <span class="big-num">{{ totalTransfee.toFixed(2) }}</span>
              </div>
            </div>
            <div class="item">
              <div class="item-tit">总优惠金额：</div>
              <div class="item-txt price">
                <span class="symbol">
                    <template v-if="activityId === 9 || activityId === 13">
                      -<img src="https://img.zhujiaxian.com/2025/09/c5cc377d7c4c44f489ddc1130c867d08.png" style="width: 16px; height: 16px; margin-right: 4px;" />
                    </template>
                    <template v-else>
                      -￥
                    </template>
                  </span>
                <span class="big-num">{{ shopReduce.toFixed(2) }}</span>
              </div>
            </div>
            <!-- 余额支付时显示余额抵扣信息 -->
            <div class="item" v-if="payType == '9'">
              <div class="item-tit">{{ activityId === 9 || activityId === 13 ? '积分支付' : '余额支付' }}：</div>
              <div class="item-txt price">
                <span class="symbol">
                    <template v-if="activityId === 9 || activityId === 13">
                      -<img src="https://img.zhujiaxian.com/2025/09/c5cc377d7c4c44f489ddc1130c867d08.png" style="width: 16px; height: 16px; margin-right: 4px;" />
                    </template>
                    <template v-else>
                      -￥
                    </template>
                  </span>
                <span v-if="total - userInfo.corporateAccounts >= 0" class="big-num">{{
                  userInfo.corporateAccounts.toFixed(2)
                }}</span>
                <span v-if="userInfo.corporateAccounts - total > 0" class="big-num">{{
                  total + totalTransfee - couponReduce
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="submit-order-footer">
        <div class="sub-order">
          <div class="item-txt">
            合计：
            <div
              class="price"
              v-if="payType == 9 && userInfo.corporateAccounts - total > 0"
            >
              <span class="symbol">
                    <template v-if="activityId === 9">
                      <img src="https://img.zhujiaxian.com/2025/09/c5cc377d7c4c44f489ddc1130c867d08.png" style="width: 16px; height: 16px; margin-right: 4px;" />
                    </template>
                    <template v-else>
                      ￥
                    </template>
                  </span>
              <span class="big-num">0</span>
              <span class="small-num">.00</span>
            </div>
            <div
              class="price"
              v-if="payType == 9 && total - userInfo.corporateAccounts > 0"
            >
              <span class="symbol">
                    <template v-if="activityId === 9 || activityId === 13">
                      <img src="https://img.zhujiaxian.com/2025/09/c5cc377d7c4c44f489ddc1130c867d08.png" style="width: 16px; height: 16px; margin-right: 4px;" />
                    </template>
                    <template v-else>
                      ￥
                    </template>
                  </span>
              <span class="big-num">{{(total - userInfo.corporateAccounts + totalTransfee - couponReduce).toFixed(2)}}</span>
            </div>
            <!-- 云闪付支付 payType 52 -->
            <div class="price" v-if="payType == 52">
              <span class="symbol">
                    <template v-if="activityId === 9 || activityId === 13">
                      <img src="https://img.zhujiaxian.com/2025/09/c5cc377d7c4c44f489ddc1130c867d08.png" style="width: 16px; height: 16px; margin-right: 4px;" />
                    </template>
                    <template v-else>
                      ￥
                    </template>
                  </span>
              <span class="big-num">{{ actualTotal.toFixed(2) }}</span>
            </div>
          </div>
        </div>
        <div class="footer-box" @click="toPay">提交订单</div>
      </div>
    </div>
     <!-- 隐藏的a标签 -->
     <a ref="weixinPayLink" href="#" style="display: none;">Weixin Pay Link</a>
  </div>
</template>
<script src="http://res.wx.qq.com/open/js/jweixin-1.6.0.js"></script>
<script>
import wx from 'weixin-js-sdk';
import { getConfirm, GetUserInfo, getSubmit,getOpenids,getPay,WXPay } from "@/https/http";
import { Dialog } from "vant";
import { getActivityIdFromRoute } from "@/utils/urlUtil";
const isWechat = () => {
		return String(navigator.userAgent.toLowerCase().match(/MicroMessenger/i)) === "micromessenger";
	}
export default {
  data() {
    return {
      radio:11,
      payType: "9",
      orderEntry: "",
      userAddr: {},
      shopCartItems: [],
      totalCount: null, //总数量
      total: null, //总价
      shopReduce: null, //总优惠金额
      totalTransfee: null, //运费
      couponReduce: null, //优惠卷减免金额
      actualTotal: null, //总价
      userInfo: {},
      addrId: 0, //地址id
      orderNumbers:'',
      isAccountFrozen: false, // 账户是否冻结状态
    };
  },
  created() {
    if (this.$route.params.addrId != undefined) {
      this.addrId = this.$route.params.addrId;
    }
    if(this.$route.params.orderEntry == '1'){
      sessionStorage.removeItem('basketIds')
    }
    this.loadOrderData();
    this.userinfo();
  },
  methods: {
    onBridgeReady(params) {
					console.log(this.params,'params');
					console.log(params,'params');
					var appids = ''
					appids = JSON.parse(localStorage.getItem("appid"))
					var timo = {
						appId:	params.appId,
						timeStamp:  params.timeStamp,
						nonceStr: params.nonceStr,
						package:  params.packageValue,
						signType: params.signType,
						paySign: params.paySign
					}
					let that = this
					WeixinJSBridge.invoke(
						'getBrandWCPayRequest',timo,
						function (res) {
							console.log(res);
							if (res.err_msg === 'get_brand_wcpay_request:ok') {
								Dialog.alert({
									title: '支付成功',
									theme: 'round-button',
									confirmButtonColor: "#bf985e"
								}).then(() => {
                  that.$router.push({ path: "/pay-result",query:{orderNumbers:that.orderNumbers,sts:1,payType:that.payType,orderType:that.orderType}});
								});
							} else if (res.err_msg === 'get_brand_wcpay_request:fail') {
                console.log('支付失败');
								Dialog.alert({
									title: '支付失败',
									theme: 'round-button',
									confirmButtonColor: "#bf985e"
								}).then(() => {
                  that.$router.push({ path: "/pay-result",query:{orderNumbers:that.orderNumbers,sts:0,payType:that.payType,orderType:that.orderType}});
								});
							} else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
                  Dialog.alert({
                    title: '支付已取消',
                    theme: 'round-button',
                    confirmButtonColor: "#bf985e"
                  }).then(() => {
                    that.$router.push({ path: "/pay-result",query:{orderNumbers:that.orderNumbers,sts:0,payType:that.payType,orderType:that.orderType}});
                  });
                }
						}
					)
				},
    getWechatCode() {
				if (isWechat) {
					let appid = "wx2fdbabccb9206fec"; //微信APPid
					let code = this.getUrlCode().code; //是否存在code
					let local = window.location.href;
					if (code == null || code === "") {
						window.location.href =
							"https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
							appid +
							"&redirect_uri=" +
							encodeURIComponent(local) +
							"&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect";
					} else {
						this.code = code;
						this.getopenid()
						console.log(this.code);
					}
				}
			},
      getUrlCode() {
				var url = location.search;
				var theRequest = new Object();
				if (url.indexOf("?") != -1) {
					var str = url.substr(1);
					var strs = str.split("&");
					for (var i = 0; i < strs.length; i++) {
						theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
					}
				}
				console.log(theRequest);
				return theRequest;
			},
			getopenid() {
				var that = this;
        getOpenids(that.code).then((res) => {
        console.log(res,'getopenids');
      });
			},
    userinfo() {
      GetUserInfo().then((res) => {
        console.log(res);
        this.userInfo = res.data;
        
        const now = new Date().getTime();
        const expirationTime = this.userInfo.corporateAccountsExpirationTime ? new Date(this.userInfo.corporateAccountsExpirationTime).getTime() : 0;
        
        this.isAccountFrozen = expirationTime < now;
        
        if (this.isAccountFrozen) {
          this.payType = '52';
        }
      });
    },
    loadOrderData() {
      var valueSession = sessionStorage.getItem("basketIds");
      console.log(valueSession, "valueSession");
      if (valueSession != undefined) {
        sessionStorage.removeItem('orderItem')
        
        let data = {
          addrId: this.addrId,
          basketIds: valueSession.split(",").map(Number),
          couponIds: [],
          attribute: 1,
          userChangeCoupon: 0,
          isScorePay: 0,
          userUseScore: 0,
        };
        getConfirm(data).then((res) => {
          console.log(667, res);
          this.userAddr = res.data.userAddr;
          this.shopCartItems =
            res.data.shopCartOrders[0].shopCartItemDiscounts[0].shopCartItems;
          this.total = res.data.total;
          this.totalCount = res.data.totalCount;
          this.totalTransfee = res.data.totalTransfee;
          this.shopReduce = res.data.shopCartOrders[0].shopReduce;
          this.couponReduce = res.data.shopCartOrders[0].couponReduce;
          this.actualTotal = res.data.actualTotal;
        });
      }else{
        const storedOrderItem = sessionStorage.getItem('orderItem');  
        const orderItem = JSON.parse(storedOrderItem);  
        console.log(orderItem,' console.log(orderItem);  ');  
       
        let data = {
          addrId: this.addrId,
          orderItem: orderItem,
          couponIds: [],
          attribute: 1,
          userChangeCoupon: 0,
          isScorePay: 0,
          userUseScore: 0,
        };
        getConfirm(data).then((res) => {
          console.log(667, res);
          this.userAddr = res.data.userAddr;
          this.shopCartItems =
            res.data.shopCartOrders[0].shopCartItemDiscounts[0].shopCartItems;
          this.total = res.data.total;
          this.totalCount = res.data.totalCount;
          this.totalTransfee = res.data.totalTransfee;
          this.shopReduce = res.data.shopCartOrders[0].shopReduce;
          this.couponReduce = res.data.shopCartOrders[0].couponReduce;
          this.actualTotal = res.data.actualTotal;
        });
      }
    },
    toPay() {
      if (!this.userAddr) {
        this.$toast.fail("请选择地址");
        return;
      }
      this.submitOrder();
    },
    submitOrder() {
      // 余额支付：余额不足时拉起组合支付（payType 切换为 10）
      if (this.payType == 9) {
        var amount = (this.actualTotal - this.userInfo.corporateAccounts).toFixed(2);
        console.log(
          this.actualTotal + "-" + this.userInfo.corporateAccounts + "=" + amount
        );
        if (amount > 0) {
          this.payType = 10;
          this.actualTotal = amount;
          console.log("余额不足，拉起组合支付", this.payType);
        }
      }
      let orderShopParam = {
        orderShopParam: [
          {
            payType: this.payType,
            remarks: "",
            attribute: 1,
            shopId: 1,
          },
        ],
      };

      getSubmit(orderShopParam).then((res) => {
        console.log(res);
        this.orderNumbers = res.data.orderNumbers;
        // 余额支付且余额充足：直接支付成功跳转结果页
        if (this.payType == 9) {
          this.$router.push({ path: "/pay-result",query:{orderNumbers:this.orderNumbers,sts:1,payType:this.payType,orderType:this.orderType}});
        } else {
          console.log(this.payType,'this.payType');
          if(this.payType == '52'){
            // 云闪付支付
            this.calUnionPay(res.data.orderNumbers);
          }
        }
      });
    },
    calWeixinPay(o){
      let openid = window.localStorage.getItem('openID');
      let data = {
        orderNumbers:o,
        payType:this.payType
        };
      getPay(data).then(res=>{
        console.log(res.data);
        if (isWechat()) {
          if (typeof WeixinJSBridge === 'undefined') {
            if (document.addEventListener) {
              document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady(res.data), false);
            } else if (document.attachEvent) {
              document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady(res.data));
              document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady(res.data));
            }
          } else {
            this.onBridgeReady(res.data);
          }
        } else {
          if (res.data && res.data.payUrl) {
            window.location.href = res.data.payUrl;
          } else {
            Dialog.alert({
              title: '支付失败',
              message: '获取微信支付链接失败',
              theme: 'round-button',
              confirmButtonColor: "#bf985e"
            });
          }
        }
      })
    },
    calAlipay(o){
      let data = {
        orderNumbers:o,
        payType:this.payType
        };
      getPay(data).then(res=>{
        console.log(res.data);
        if (res.data && res.data.payUrl) {
          window.location.href = res.data.payUrl;
        } else {
          Dialog.alert({
            title: '支付失败',
            message: '获取支付宝支付链接失败',
            theme: 'round-button',
            confirmButtonColor: "#bf985e"
          });
        }
      })
    },
    // 云闪付支付方法：/p/order/pay 接口 res.data 直接返回支付链接字符串
    calUnionPay(o){
      let data = {
        orderNumbers:o,
        payType:this.payType
        };
      getPay(data).then(res=>{
        console.log(res.data);
        if (res.data) {
          window.location.href = res.data;
        } else {
          Dialog.alert({
            title: '支付失败',
            message: '获取云闪付支付链接失败',
            theme: 'round-button',
            confirmButtonColor: "#bf985e"
          });
        }
      })
    },

    onClickLeft() {
      this.$router.go(-1);
    },
    onAdd() {
      this.$router.push({ name: "delivery-address",params:{order:0} });
    },
  },
};
</script>
<style lang="less" scoped>
/* 样式内容无需变动，保持原样即可 */
.container {
  height: 100%;
  box-sizing: border-box;
  color: #333;
  font-family: helvetica, "Heiti SC", PingFangSC-Light;
  .van-icon__image {
    width: 1.5em !important;
    height: 1.5em !important;
  }
  .van-cell {
    .van-cell__left-icon {
      width: 32px !important;
      height: 32px !important;
    }
  }
  .submit-order {
    padding-bottom: 60px;
    .delivery-addr {
      position: relative;
      background: #fff;
      .whole {
        padding: 0 20px 0 60px;
      }
      .addr-icon {
        width: 30px;
        height: 30px;
        display: block;
        position: absolute;
        left: 15px;
        top: 24px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .user-info {
        padding-top: 10px;
        line-height: 24px;
        word-wrap: break-word;
        word-break: break-all;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        .item {
          font-size: 21px;
          margin-right: 15px;
          vertical-align: top;
          display: inline-block;
          font-family: HarmonyOS Sans SC;
        }
        .items {
          font-size: 13px;
          color: #999;
          width: 90%;
          font-family: HarmonyOS-SC-Reg;
        }
      }
      .addr {
        font-size: 13px;
        line-height: 21px;
        color: #999;
        width: 90%;
        padding-bottom: 10px;
        margin-top: 7px;
        font-family: HarmonyOS-SC-Reg;
      }
      .arrow {
        width: 7px;
        height: 7px;
        border-top: 1px solid #777;
        border-right: 1px solid #777;
        transform: rotate(45deg);
        position: absolute;
        right: 15px;
        top: 30px;
      }
      .address-wrap {
        position: relative;
      }
      .address-wrap::before {
        position: absolute;
        right: 0;
        bottom: 0;
        left: 0;
        height: 2px;
        background: repeating-linear-gradient(
          -45deg,
          #fcb8b8 0,
          #fcb8b8 20%,
          transparent 0,
          transparent 25%,
          #a3d9eb 0,
          #a3d9eb 41%,
          transparent 0,
          transparent 50%
        );
        background-size: 80px;
        content: "";
        background-image: repeating-linear-gradient(
          -45deg,
          rgb(252, 184, 184) 0px,
          rgb(252, 184, 184) 20%,
          transparent 0px,
          transparent 25%,
          rgb(163, 217, 235) 0px,
          rgb(163, 217, 235) 41%,
          transparent 0px,
          transparent 50%
        );
      }
    }
    .prod-item {
      background-color: #fff;
      margin-top: 7px;
      font-size: 14px;
      border-radius: 8px;
      .prod-block {
        background: #fff;
        .item-box {
          position: relative;
          .item-cont {
            display: flex;
            align-items: center;
            padding: 15px 0;
            padding-right: 10px;
            margin-left: 15px;
            border-bottom: 1px solid #f1f1f1;
            .prod-pic {
              font-size: 0;
              display: block;
              width: 80px;
              height: 80px;
              overflow: hidden;
              background: #fff;
              margin-right: 8px;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .prod-info {
              margin-left: 5px;
              font-size: 14px;
              width: 100%;
              position: relative;
              height: 80px;
              -ms-flex: 1;
              -webkit-box-flex: 1;
              -moz-box-flex: 1;
              flex: 1;
              .prodname {
                font-size: 14px;
                line-height: 20px;
                max-height: 43px;
                overflow: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                text-overflow: ellipsis;
                word-break: break-all;
                font-family: HarmonyOS-SC-Reg;
              }
              .price-nums {
                .prodprice {
                  position: absolute;
                  bottom: 0;
                  .symbol {
                    font-size: 12px;
                  }
                  .big-num {
                    font-size: 16px;
                  }
                  .small-num {
                    font-size: 12px;
                  }
                }
                .prodcount {
                  position: absolute;
                  bottom: 3px;
                  right: 0;
                  color: #999;
                  font-family: verdana;
                }
              }
            }
          }
        }
      }
      .total-num {
        display: flex;
        justify-content: space-between;
        padding: 10px 15px;
        font-size: 14px;
        font-family: HarmonyOS-SC-Reg;
        .prodcount {
          margin-right: 10px;
          color: #939393;
        }
        .prodprice {
          display: inline-block;
          color: #333;
          .symbol {
            font-size: 12px;
          }
          .big-num {
            font-size: 16px;
          }
          .small-num {
            font-size: 12px;
          }
        }
      }
    }
    .order-msg {
      background: #fff;
      margin-top: 7px;
      font-size: 14px;
      border-radius: 12px;
      .msg-item:first-child {
        border: 0;
        font-family: HarmonyOS-SC-Reg;
      }
      .msg-item {
        border-top: 1px solid #f1f1f1;
        .item {
          position: relative;
          padding: 8px 15px;
          align-items: center;
          display: flex;
          .item-tit {
            line-height: 24px;
            color: #909090;
          }
          .price {
            text-align: right;
          }
          .item-txt {
            -webkit-box-flex: 1;
            -moz-box-flex: 1;
            flex: 1;
            font-family: arial;
            max-height: 24px;
            overflow: hidden;
            line-height: 24px;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            text-overflow: ellipsis;
            word-break: break-all;
          }
          .item-txt {
            height: 50px;
          }
          .price {
            font-family: Arial;
            display: inline-block;
            color: #e43130;
          }
        }
      }
    }
  }
  .submit-order-footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    max-width: 375px;
    background: #fff;
    margin: auto;
    display: -webkit-flex;
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    align-items: center;
    font-size: 13px;
    box-shadow: 0 -1px 3px rgba(0, 0, 0, 0.05);
    .sub-order {
      flex: 1;
      margin: 0 15px;
      line-height: 50px;
      display: block;
      text-align: left;
      font-size: 14px;
      background: #fff;
      z-index: 5;
      .item-txt {
        height: 50px;
        line-height: 50px;
        .price {
          display: inline;
          color: #e43130;
          font-size: 14px;
          font-family: Arial;
          .symbol {
            font-size: 12px;
          }
          .big-num {
            font-size: 16px;
          }
          .small-num {
            font-size: 12px;
          }
        }
      }
    }
    .footer-box {
      padding: 0 5px;
      width: 100px;
      background: linear-gradient(90deg, #f35151 0%, #f38364 100%);
      text-align: center;
      color: #fff;
      font-size: 15px;
      border-radius: 30px;
      height: 2.8em;
      line-height: 2.8em;
      margin-right: 10px;
    }
  }
}
</style>